<script setup lang="ts">
import { Accordion, AccordionItemContainer } from '@sozialinfo/kompass'

defineProps<{ items: string[] }>()
</script>

<template>
  <Accordion
    type="single"
    collapsible
  >
    <AccordionItemContainer
      v-for="(item, index) in items"
      :key="item"
      :item-title="item"
      :value="String(index)"
    >
      <slot :name="`${index}-item`" />
    </AccordionItemContainer>
  </Accordion>
</template>
